<template>
  <div class="container">
    <div class="row">
      <div class="mb-3">
        <a
          v-if="!AddMode"
          class="d-inline float-right mx-2 mt-1"
          href="javascript:;"
          @click="
            AddMode = !AddMode
            EditMode = false
            addnew()
          "
          title="افزودن نامه جدید"
        >
          <h4><i class="fas fa-plus" style="color: var(--logo-color) !important"></i></h4>
        </a>
        <a v-if="AddMode" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddMode = !AddMode" title="لغو افزودن">
          <h4><i class="fas fa-times text-danger"></i></h4>
        </a>

        <a v-if="!AddMode && ftp != null && $session.get('Menu').filter((x) => x.id == 2263)[0].isMojaz == 1" target="_blank" class="d-inline float-right mx-2 mt-1" :href="ftp + Codebazaryabi + '/'" title="">
          <h4><i class="fad fa-folders"></i></h4>
        </a>
      </div>
      <div v-if="AndicatorList.length < 1 && !AddMode" class="col-12 p-4 border Rounded">
        <h4>نامه ای ثبت نشده است.</h4>
      </div>
      <div v-if="AndicatorList.length > 0 && !AddMode" class="col-12 p-0">
        <div class="row w-100">
          <div class="col-2 p-2">
            <div class="col-12 pt-3 my-2 text-sm-center w-100 tabheader" @click="ChangeTab(tab.TabNumber)" v-for="(tab, index) in Tablist" :key="index" :class="divToShow == index ? 'text-primary activetab' : ''">
              <span class="mt-2"> {{ tab.header }} </span>
            </div>
          </div>
          <div class="col-10 w-100">
            <div class="row TabBody" style="min-height: 40vh">
              <div class="col-12 row activetab" v-if="divToShow == 0">
                <BnpGrid :hasRowNum="true" v-if="$store.state.renderComponentTicket" :propsColumn="Columns" :propsRows="ListAndicator0" :action="true">
                  <template slot="action-slot" slot-scope="props">
                    <a v-if="props.props.Filepath.indexOf('.') > 0 || props.props.FileName.indexOf('.') > 0" :data-title="'دانلود'" @click="Download(props.props)" class="mx-1"><i class="fad fa-download text-warning"></i></a>
                    <a v-else @click="Upload(props.props)" :data-title="'بارگذاری'" class="mx-1"> <i class="fad fa-upload text-info"></i></a>
                    <a @click="OpenModal(props.props)" :data-title="'پیوست ها و بایگانی ها'" class="mx-1"> <i class="fad fa-folder"></i></a>
                    <a v-if="props.props.tblUserGrpInsert == $session.get('UserInfo').tblUserGrpId && props.props.DateTimeInsert.substring(0, 10) == $store.state.JalaliDate" @click="Edit(props.props)"> <i class="fas fa-pen"></i></a>
                    <a v-if="candelete(props.props)" @click="DeleteFile(props.props)" :data-title="'حذف فایل'" class="mx-1"> <i class="fad fa-times text-danger"></i></a>
                  </template>
                </BnpGrid>
              </div>
              <div class="col-12 row activetab" v-if="divToShow == 1">
                <BnpGrid :hasRowNum="true" v-if="$store.state.renderComponentTicket" :propsColumn="Columns" :propsRows="ListAndicator1" :action="true">
                  <template slot="action-slot" slot-scope="props">
                    <a v-if="props.props.Filepath.indexOf('.') > 0 || props.props.FileName.indexOf('.') > 0" :data-title="'دانلود'" @click="Download(props.props)" class="mx-1"><i class="fad fa-download text-warning"></i></a>
                    <a v-else @click="Upload(props.props)" :data-title="'بارگذاری'" class="mx-1"> <i class="fad fa-upload text-info"></i></a>
                    <a @click="OpenModal(props.props)" :data-title="'پیوست ها و بایگانی ها'" class="mx-1"> <i class="fad fa-folder"></i></a>
                    <a v-if="candelete(props.props)" @click="DeleteFile(props.props)" :data-title="'حذف فایل'" class="mx-1"> <i class="fad fa-times text-danger"></i></a>
                  </template>
                </BnpGrid>
              </div>
              <div class="col-12 row activetab" v-if="divToShow == 2">
                <BnpGrid :hasRowNum="true" v-if="$store.state.renderComponentTicket" :propsColumn="Columns" :propsRows="ListAndicator2" :action="true">
                  <template slot="action-slot" slot-scope="props">
                    <a v-if="props.props.Filepath.indexOf('.') > 0 || props.props.FileName.indexOf('.') > 0" :data-title="'دانلود'" @click="Download(props.props)" class="mx-1"><i class="fad fa-download text-warning"></i></a>
                    <a v-else @click="Upload(props.props)" :data-title="'بارگذاری'" class="mx-1"> <i class="fad fa-upload text-info"></i></a>
                    <a @click="OpenModal(props.props)" :data-title="'پیوست ها و بایگانی ها'" class="mx-1"> <i class="fad fa-folder"></i></a>
                    <a v-if="candelete(props.props)" :data-title="'حذف فایل'" @click="DeleteFile(props.props)" class="mx-1"><i class="fad fa-times text-danger"></i></a>
                  </template>
                </BnpGrid>
              </div>
              <div class="col-12 row activetab" v-if="divToShow == 3">
                <BnpGrid :hasRowNum="true" v-if="$store.state.renderComponentTicket" :propsColumn="Columns" :propsRows="ListAndicator3" :action="true">
                  <template slot="action-slot" slot-scope="props">
                    <a v-if="props.props.Filepath.indexOf('.') > 0 || props.props.FileName.indexOf('.') > 0" :data-title="'دانلود'" @click="Download(props.props)" class="mx-1"><i class="fad fa-download text-warning"></i></a>
                    <a v-else @click="Upload(props.props)" :data-title="'بارگذاری'" class="mx-1"> <i class="fad fa-upload text-info"></i></a>
                    <a @click="OpenModal(props.props)" :data-title="'پیوست ها و بایگانی ها'" class="mx-1"> <i class="fad fa-folder"></i></a>
                    <a v-if="candelete(props.props)" :data-title="'حذف فایل'" @click="DeleteFile(props.props)" class="mx-1"><i class="fad fa-times text-danger"></i></a>
                  </template>
                </BnpGrid>
              </div>
              <div class="col-12 row activetab" v-if="divToShow == 4">
                <BnpGrid :hasRowNum="true" v-if="$store.state.renderComponentTicket" :propsColumn="Columns" :propsRows="ListAndicator4" :action="true">
                  <template slot="action-slot" slot-scope="props">
                    <a v-if="props.props.Filepath.indexOf('.') > 0 || props.props.FileName.indexOf('.') > 0" :data-title="'دانلود'" @click="Download(props.props)" class="mx-1"><i class="fad fa-download text-warning"></i></a>
                    <a v-else @click="Upload(props.props)" :data-title="'بارگذاری'" class="mx-1"> <i class="fad fa-upload text-info"></i></a>
                    <a @click="OpenModal(props.props)" :data-title="'پیوست ها و بایگانی ها'" class="mx-1"> <i class="fad fa-folder"></i></a>
                    <a v-if="candelete(props.props)" :data-title="'حذف فایل'" @click="DeleteFile(props.props)" class="mx-1"><i class="fad fa-times text-danger"></i></a>
                  </template>
                </BnpGrid>
              </div>
              <div class="col-12 row activetab" v-if="divToShow == 5">
                <BnpGrid :hasRowNum="true" v-if="$store.state.renderComponentTicket" :propsColumn="Columns" :propsRows="ListAndicator5" :action="true">
                  <template slot="action-slot" slot-scope="props">
                    <a v-if="props.props.Filepath.indexOf('.') > 0 || props.props.FileName.indexOf('.') > 0" :data-title="'دانلود'" @click="Download(props.props)" class="mx-1"><i class="fad fa-download text-warning"></i></a>
                    <a v-else @click="Upload(props.props)" :data-title="'بارگذاری'" class="mx-1"> <i class="fad fa-upload text-info"></i></a>
                    <a @click="OpenModal(props.props)" :data-title="'پیوست ها و بایگانی ها'" class="mx-1"> <i class="fad fa-folder"></i></a>
                    <a v-if="candelete(props.props)" :data-title="'حذف فایل'" @click="DeleteFile(props.props)" class="mx-1"><i class="fad fa-times text-danger"></i></a>
                  </template>
                </BnpGrid>
              </div>
              <div class="col-12 row activetab" v-if="divToShow == 6">
                <BnpGrid :hasRowNum="true" v-if="$store.state.renderComponentTicket" :propsColumn="Columns" :propsRows="ListAndicator6" :action="true">
                  <template slot="action-slot" slot-scope="props">
                    <a v-if="props.props.Filepath.indexOf('.') > 0 || props.props.FileName.indexOf('.') > 0" :data-title="'دانلود'" @click="Download(props.props)" class="mx-1"><i class="fad fa-download text-warning"></i></a>
                    <a v-else @click="Upload(props.props)" :data-title="'بارگذاری'" class="mx-1"> <i class="fad fa-upload text-info"></i></a>
                    <a @click="OpenModal(props.props)" :data-title="'پیوست ها و بایگانی ها'" class="mx-1"> <i class="fad fa-folder"></i></a>
                    <a v-if="candelete(props.props)" :data-title="'حذف فایل'" @click="DeleteFile(props.props)" class="mx-1"><i class="fad fa-times text-danger"></i></a>
                  </template>
                </BnpGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="AddMode" class="col-12" id="AddAdress">
        <div class="row">
          <div class="col-lg-3 col-12 p-2">
            <small id="LblTarafname">نوع </small>
            <SearchableCombo
              :edit="false"
              :grp="36"
              :code="null"
              @ResultCombo="GetResulttblComboGrp36Noe"
              :rownumintable="3"
              :defaultvalue="DataAxios.ArryfildValue.tblComboGrp36Noe"
              :action="'TblCrmCombo/GetComboById'"
              :method="'POST'"
              :idinput="'tblComboGrp36Noe'"
              :keyItem="'tblComboGrp36Noe'"
              :disabled="false"
              :ClassProps="'required'"
            >
            </SearchableCombo>
          </div>
          <div class="col-lg-3 col-12 p-2">
            <small>شماره نامه</small>
            <input disabled type="text" v-model="DataAxios.ArryfildValue.Number" class="form-control text-left required" />
          </div>
          <div class="col-lg-3 col-12 p-2">
            <small id="LblPersonle">پرسنل مخاطب </small>
            <SearchableCombo
              :edit="false"
              :grp="CustomerId"
              :code="null"
              @ResultCombo="GetResultPersonel"
              :rownumintable="3"
              :defaultvalue="DataAxios.ArryfildValue.tblPersonelId"
              :action="'TblCrmCombo/GetPersonelCombo'"
              :method="'POST'"
              :idinput="'Personel'"
              :keyItem="'Personel'"
              :disabled="false"
              :ClassProps="'required'"
            >
            </SearchableCombo>
          </div>

          <div class="col-lg-3 col-12 p-2">
            <small id="lblAndicatorDate"> تاریخ</small>
            <date-picker color="dimgray" input-class="required form-control" id="AndicatorDate" v-model="DataAxios.ArryfildValue.AndicatorDate" clearable :editable="true" placeholder=" تاریخ "></date-picker>
          </div>
          <div class="col-lg-6 col-12 p-2">
            <small id="LblSubject"> موضوع</small>
            <textarea id="Subject" class="form-control required" v-model="DataAxios.ArryfildValue.Subject"></textarea>
          </div>
          <!-- <div class="col-lg-3 col-12 p-2">
            <small id="LblSubject"> نام فایل</small>
            <input id="FileName" class="form-control required" type="text" v-model="DataAxios.ArryfildValue.FileName" />
          </div> -->
          <div class="col-md-5 col-12">
            <small>فایل</small>
            <Uploader @upload="upload"></Uploader>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-9 col-12"></div>
          <div class="col-md-3 col-12">
            <button v-if="!EditMode" @click="Insert" class="btn w-100 btn-success">ثبت نامه</button>
            <button v-else @click="SubmitEdit" class="btn w-100 btn-warning">بروزرسانی نامه</button>
          </div>
        </div>
      </div>
      <Modal v-if="$store.state.Modal && MODAL" @Close="closeModal" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'">
        <template v-slot:header>
          <h4 class="mr-4 d-inline text-warning">{{ VisitArchiveFile.Number }} - {{ VisitArchiveFile.Subject }}</h4></template
        >
        <template v-slot:body>
          <AndicatorModal v-if="ArchiveModal" @Delete="DeleteFile" @Inserted="refresh" :master="VisitArchiveFile"> </AndicatorModal>
          <Andicatorupload @Done="done" :master="VisitArchiveFile" v-if="Uploadmodal"></Andicatorupload> </template
      ></Modal>
    </div>
  </div>
</template>
<script>
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import FormData from 'form-data'
import datePicker from 'vue-persian-datetime-picker'
import CardBox from '@/components/CardBox/CardBox.vue'
import Tab from '@/components/Tab/Tab.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Uploader from '@/components/Uploader/Uploader.vue'
import AndicatorModal from './AndicatorModal.vue'
import Modal from '@/pages/Modal/Modal.vue'
import Andicatorupload from './Andicatorupload.vue'
import { forEach } from '@/assets/FA/js/v4-shims'

export default {
  props: ['CustomerId', 'AndicatorList', 'Codebazaryabi', 'ftp'],
  data() {
    return {
      MODAL: false,
      ArchiveModal: false,
      Uploadmodal: false,
      VisitArchiveFile: {},
      Tablist: [],
      ListAndicator0: [],
      ListAndicator1: [],
      ListAndicator2: [],
      ListAndicator3: [],
      ListAndicator4: [],
      ListAndicator5: [],
      ListAndicator6: [],
      divToShow: 0,
      Columns: [
        { id: 2416, name: 'Number', visibility: true, label: 'شماره نامه' },
        { id: 2417, name: 'Subject', visibility: true, label: 'موضوع' },
        { id: 2465, name: 'AndicatorDate', visibility: true, label: 'تاریخ ' },
      ],
      status: '',
      AddMode: false,
      EditMode: false,
      NewAndicator: {
        Id: 55,
        tblPersonelId: 0,
        tblComboGrp36Noe: 0,
        tblCustomerId: this.CustomerId,
        FileName: '',
        Number: '',
        Subject: '',
        AndicatorDate: '',
        Filepath: '',
        DateTimeInsert: '',
        DateTimeLastEdit: '',
        tblUserGrpIdLastEdit: null,
        tblUserGrpInsert: this.$session.get('UserInfo').tblUserGrpId,
        file: null,
        parentId: null,
      },
      DataAxios: {
        Action: 'Andicator/AddAndicator',
        Method: 'Post',
        ArryfildValue: {},
      },
      rendergrid: true,
      DataAxoisCol: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmAndicator',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      Column: [],
    }
  },
  methods: {
    Edit(andicator) {
      this.DataAxios.ArryfildValue = JSON.parse(JSON.stringify(andicator))
      this.status = 'Edit'
      this.AddMode = true
      this.EditMode = true
    },
    done(data) {
      if (data.done == 'OK') {
        this.$emit('Inserted', {
          done: 'OK',
          activeTab: 6,
        })
      }
    },
    Upload(andiInfo) {
      this.Uploadmodal = true
      this.ArchiveModal = false
      this.VisitArchiveFile = andiInfo
      this.$store.state.Modal = true
      this.MODAL = true
    },
    OpenModal(MainFile) {
      this.Uploadmodal = false
      this.ArchiveModal = true
      this.VisitArchiveFile = MainFile
      this.$store.state.Modal = true
      this.MODAL = true
    },
    closeModal() {
      this.$store.state.Modal = false
      this.MODAL = false
    },
    ChangeTab(index) {
      // console.log(index)
      this.divToShow = index
      this.$store.state.renderComponentTicket = false
      this.$nextTick(() => {
        this.$store.state.renderComponentTicket = true
      })
    },
    addnew() {
      this.DataAxios.ArryfildValue = JSON.parse(JSON.stringify(this.NewAndicator))
      this.status = 'add'
    },
    GetResultPersonel(data) {
      this.DataAxios.ArryfildValue.tblPersonelId = data.id
    },
    GetResulttblComboGrp36Noe(data) {
      if (data.id != null) {
        this.DataAxios.ArryfildValue.tblComboGrp36Noe = data.id
        this.GetAndicatorNumber(data.id)
        this.DataAxios.ArryfildValue.Filepath = 'AndicatorFile\\' + this.Codebazaryabi + '\\' + data.name
      }
    },
    upload(data) {
      this.DataAxios.ArryfildValue.file = data
    },
    SubmitEdit() {
      if (this.$ValidForm('AddAdress')) {
        var formData = new FormData()

        formData.append('Number', this.DataAxios.ArryfildValue.Number)
        formData.append('FileName', this.DataAxios.ArryfildValue.FileName)
        formData.append('tblCustomerId', this.DataAxios.ArryfildValue.tblCustomerId)
        formData.append('tblComboGrp36Noe', this.DataAxios.ArryfildValue.tblComboGrp36Noe)
        formData.append('tblPersonelId', this.DataAxios.ArryfildValue.tblPersonelId)
        formData.append('Id', this.DataAxios.ArryfildValue.Id)
        formData.append('Subject', this.DataAxios.ArryfildValue.Subject)
        formData.append('AndicatorDate', this.DataAxios.ArryfildValue.AndicatorDate)
        formData.append('Filepath', this.DataAxios.ArryfildValue.Filepath)
        formData.append('DateTimeInsert', this.DataAxios.ArryfildValue.DateTimeInsert)
        formData.append('DateTimeLastEdit', this.$session.get('UserInfo').tblUserGrpId)
        formData.append('tblUserGrpIdLastEdit', this.DataAxios.ArryfildValue.tblUserGrpIdLastEdit)
        formData.append('tblUserGrpInsert', this.DataAxios.ArryfildValue.tblUserGrpInsert)
        formData.append('file', this.DataAxios.ArryfildValue.file)

        var DataAxiosEdit = {
          Action: 'Andicator/EditAndicator',
          Method: 'Post',
          ArryfildValue: {},
        }
        DataAxiosEdit.ArryfildValue = formData

        this.$PostFormData(DataAxiosEdit)
          .then((result) => {
            if (result.status == 'success') {
              this.AddMode = false
              this.$mySweetDefaultTost('عملیات موفق', 'نامه با موفقیت ویرایش شد', 'success', 2000)
              this.$emit('Inserted', {
                done: 'OK',
                activeTab: 6,
              })
            } else {
              this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی در ویرایش بوجود امده است', 'warning', 2000)
            }
          })
          .catch((error) => {
            this.$mySweetDefaultTost('عملیات ناموفق', 'خطای سیستم', 'error', 2000)
            console.error(error)
          })
      }
    },
    Insert() {
      if (this.$ValidForm('AddAdress')) {
        var formData = new FormData()

        formData.append('Number', this.DataAxios.ArryfildValue.Number)
        formData.append('FileName', this.DataAxios.ArryfildValue.FileName)
        formData.append('tblCustomerId', this.DataAxios.ArryfildValue.tblCustomerId)
        formData.append('tblComboGrp36Noe', this.DataAxios.ArryfildValue.tblComboGrp36Noe)
        formData.append('tblPersonelId', this.DataAxios.ArryfildValue.tblPersonelId)
        formData.append('Id', this.DataAxios.ArryfildValue.Id)
        formData.append('Subject', this.DataAxios.ArryfildValue.Subject)
        formData.append('AndicatorDate', this.DataAxios.ArryfildValue.AndicatorDate)
        formData.append('Filepath', this.DataAxios.ArryfildValue.Filepath)
        formData.append('DateTimeInsert', this.DataAxios.ArryfildValue.DateTimeInsert)
        formData.append('DateTimeLastEdit', this.DataAxios.ArryfildValue.DateTimeLastEdit)
        formData.append('tblUserGrpIdLastEdit', this.DataAxios.ArryfildValue.tblUserGrpIdLastEdit)
        formData.append('tblUserGrpInsert', this.DataAxios.ArryfildValue.tblUserGrpInsert)
        formData.append('file', this.DataAxios.ArryfildValue.file)
        this.DataAxios.ArryfildValue = formData
        this.$PostFormData(this.DataAxios)
          .then((result) => {
            if (result.status == 'success') {
              this.AddMode = false
              this.$mySweetDefaultTost('عملیات موفق', 'نامه جدید با موفقیت ثبت شد', 'success', 2000)
              this.$emit('Inserted', {
                done: 'OK',
                activeTab: 6,
              })
            } else {
              this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی در ثبت بوجود امده است', 'warning', 2000)
            }
          })
          .catch((error) => {
            this.$mySweetDefaultTost('عملیات ناموفق', 'خطای سیستم', 'error', 2000)
            console.error(error)
          })
      }
    },
    GetAndicatorNumber(ID) {
      if (!this.EditMode) {
        var DataAxiosAndicatorAxios = { Action: 'Andicator/GetAndicatorNumber', Method: 'POST', ArryfildValue: { Id: ID } }
        this.$PostData(DataAxiosAndicatorAxios).then((result) => {
          this.DataAxios.ArryfildValue.Number = result.andicatorNumber
        })
      }
    },
    Download(data) {
      var DataAxios = {
        Action: 'Download',
        Method: 'Post',
        ArryfildValue: {
          FilePath: data.Filepath,
          FileName: data.FileName,
          Number: data.Number,
        },
      }
      this.$PostData(DataAxios).then((response) => {
        var fileLink = document.createElement('a')
        fileLink.href = 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + response.data.fileContents
        fileLink.setAttribute('download', response.data.fileDownloadName)
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    },
    DeleteFile(data) {
      if (data.data) {
        var id = Number(data.data.Id)
        this.$SweetQustion('هشدار', 'ایا از حذف فایل این نامه اطمینان دارید؟', 'info', 'بله', 'انصراف', id, this.DeleteFileAction, this.cancel)
      } else {
        this.$SweetQustion('هشدار', 'ایا از حذف فایل این نامه اطمینان دارید؟', 'info', 'بله', 'انصراف', data.id, this.DeleteFileAction, this.cancel)
      }
    },
    DeleteFileAction(id) {
      var DataAxiosDeleteFile = { Method: 'POST', Action: 'Andicator/ArchiveAndicator', ArryfildValue: { Id: id } }
      this.$PostData(DataAxiosDeleteFile).then((result) => {
        this.$mySweetDefaultTost('عملیات موفق', 'نامه مورد نظر بایگانی شد', 'success', 2000)
        this.$emit('Inserted', {
          done: 'OK',
          activeTab: 6,
        })
        this.$store.state.Modal = false
        this.MODAL = false

        if (result.status == 'success') {
        } else {
          this.$mySweetDefaultTost('عملیات ناموفق', result.msg, 'warning', 2000)
          this.$store.state.Modal = false
          this.MODAL = false
        }
      })
    },
    refresh() {
      this.$store.state.Modal = false
      this.MODAL = false
      this.$emit('Inserted', {
        done: 'OK',
        activeTab: 6,
      })
    },
    candelete(data) {
      return ((data.Filepath.indexOf('.') > 0 || data.FileName.indexOf('.') > 0) && this.$session.get('UserInfo').tblUserGrpId && data.DateTimeInsert.substring(0, 10) == this.$store.state.JalaliDate) || this.$session.get('UserInfo').tblUserGrpId == 1
    },
  },
  components: { SearchableCombo, datePicker, CardBox, Tab, BnpGrid, Uploader, AndicatorModal, Modal, Andicatorupload },
  created() {
    var dastresi = this.$session.get('Menu').filter((x) => x.ParentId == 2262)
    if (dastresi[1].isMojaz) {
      this.Tablist.push({ header: 'ارسالی', active: this.activeTab == 1, TabNumber: 0 })
    }
    if (dastresi[2].isMojaz) {
      this.Tablist.push({ header: 'دریافتی', active: this.activeTab == 2, TabNumber: 1 })
    }
    if (dastresi[3].isMojaz) {
      this.Tablist.push({ header: 'قرارداد ', active: this.activeTab == 3, TabNumber: 2 })
    }
    if (dastresi[4].isMojaz) {
      this.Tablist.push({ header: 'لیست قیمت', active: this.activeTab == 4, TabNumber: 3 })
    }
    if (dastresi[5].isMojaz) {
      this.Tablist.push({ header: 'فاکتور', active: this.activeTab == 5, TabNumber: 4 })
    }
    if (dastresi[6].isMojaz) {
      this.Tablist.push({ header: 'صورتجلسه ', active: this.activeTab == 6, TabNumber: 5 })
    }
    if (dastresi[7].isMojaz) {
      this.Tablist.push({ header: 'پیش فاکتور', active: this.activeTab == 7, TabNumber: 6 })
    }
    this.AndicatorList.sort((a, b) => {
      if (a.AndicatorDate > b.AndicatorDate) {
        return -1
      }
      if (a.AndicatorDate < b.AndicatorDate) {
        return 1
      }
      return 0
    })
    this.AndicatorList.forEach((element) => {
      element.Codebazaryabi = this.Codebazaryabi
      if (element.tblComboGrp36Noe == 1633) {
        this.ListAndicator0.push(element)
      }
      if (element.tblComboGrp36Noe == 1634) {
        this.ListAndicator1.push(element)
      }
      if (element.tblComboGrp36Noe == 1635) {
        this.ListAndicator2.push(element)
      }
      if (element.tblComboGrp36Noe == 1636) {
        this.ListAndicator3.push(element)
      }
      if (element.tblComboGrp36Noe == 1637) {
        this.ListAndicator4.push(element)
      }
      if (element.tblComboGrp36Noe == 1638) {
        this.ListAndicator5.push(element)
      }
      if (element.tblComboGrp36Noe == 1641) {
        this.ListAndicator6.push(element)
      }
    })
  },
}
</script>
<style scoped>
.tabheader {
  -webkit-border-top-left-radius: 20px;
  -webkit-border-top-right-radius: 20px;
  -moz-border-radius-topleft: 20px;
  -moz-border-radius-topright: 20px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-top: 2px solid var(--sidebar-bg-color);
  border-right: 2px solid var(--sidebar-bg-color);
  border-left: 2px solid var(--sidebar-bg-color);
  background: var(--sidebar-bg-color);
  cursor: pointer;
}
.TabBody {
  background: var(--sidebar-action-bg);
}
.activetab {
  background: var(--sidebar-action-bg);
}
.activetab span {
  color: var(--logo-color) !important;
}
</style>
